module.exports = __webpack_public_path__ + "static/media/템플릿 목록.21d755fd.jpg";